import { render, staticRenderFns } from "./CbdTablePage.vue?vue&type=template&id=16f5ef4f"
import script from "./CbdTablePage.vue?vue&type=script&lang=js"
export * from "./CbdTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports